import api from './api';

export const socialCarbonService = {
  // 🔹 Buscar lista de contas (account_list_view)
  getAccountListView: async (token) => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await api.patch('/social_carbon/account_list_view/', { json: 1 }, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar lista de contas (Social Carbon):', error);
      throw error;
    }
  },

  getAssets: async (account_address, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };

      const response = await api.patch(
        '/social_carbon/get_assets/',
        { account_id: account_address },
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar assets da conta Social Carbon:', error);
      throw error;
    }
  },

  getProjectsByAccount: async (account_address, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };

      const response = await api.patch(
        '/social_carbon/project_list_view/',
        { account_id: account_address },
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar projetos da conta Social Carbon:', error);
      throw error;
    }
  },

  getRetirementsByAccount: async (account_address, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };

      const response = await api.patch(
        '/social_carbon/retirement_list_view/',
        { account_id: account_address },
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar aposentadorias da conta Social Carbon:', error);
      throw error;
    }
  },

  authenticateUser: async (credentials, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };

      await api.post(
        '/social_carbon/get_authenticate/',
        {
          wilder_user: credentials.email,
          password: credentials.password,
        },
        { headers }
      );
    } catch (error) {
      console.error('❌ Erro na autenticação do usuário Social Carbon:', error);
      throw error;
    }
  },

  // 🔹 Obtém sessão do usuário após autenticação
  getUserSession: async (credentials, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };

      const response = await api.post(
        '/social_carbon/wilder/get_user_session/',
        {
          username: credentials.email,
          password: credentials.password,
          pin: credentials.pin,
        },
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar sessão do usuário Social Carbon:', error);
      throw error;
    }
  },

  syncAccountsWithWilder: async (userId, sessao, token) => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await api.patch(
        `/social_carbon/wilder/get_accounts/${userId}/`,
        { user_session: sessao },
        { headers }
      );
    } catch (error) {
      console.error("❌ Erro ao sincronizar contas com a Wilder:", error);
      throw error;
    }
  },

  fetchUpdatedAccounts: async (token) => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await api.patch(
        '/social_carbon/account_list_view/',
        { json: 1 }, // Body simples para satisfazer o método PATCH
        { headers }
      );

      // Retorna apenas o array de contas
      return response.data.accounts;
    } catch (error) {
      console.error('❌ Erro ao buscar contas atualizadas:', error);
      throw error;
    }
  },

  updateRetirementsFromWilder: async (token) => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await api.patch(
        '/social_carbon/wilder/get_retirements_from_wilder/',
        null, // corpo vazio
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar aposentadorias da Wilder:', error);
      throw error;
    }
  },

  setRetirement: async (formData, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };

      const response = await api.post(
        '/social_carbon/set_retirement/',
        {
          credit_name: formData.credit_name,
          quantity: formData.quantity,
          beneficiary: formData.beneficiary,
          purpose: formData.purpose,
          wilder_user: formData.wilder_user,
          password: formData.password,
          pin: formData.pin,
        },
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao realizar aposentadoria de créditos:', error);
      throw error;
    }
  },

};
